import React, { FC } from 'react';

import { Header } from './elements/Header';
import { Links } from './elements/Links';
import { Products } from './elements/Products';
import { Video } from './elements/Video';

import styles from './index.module.sass';

type ITheMastersLandingProps = {
  isAuthorized: boolean;
  isLive: boolean;
  soldOutProducts: number[];
};

const TheMastersLanding: FC<ITheMastersLandingProps> = ({
  isAuthorized = false,
  isLive = false,
  soldOutProducts = [],
}) => {
  const comingSoon = !isLive && !isAuthorized;
  return (
    <div className={styles.container}>
      <div>
        <Header comingSoon={comingSoon} />
        <Products comingSoon={comingSoon} soldOutProducts={soldOutProducts} />
      </div>
      <Links comingSoon={comingSoon} />
      <Video />
    </div>
  );
}

export default TheMastersLanding;
